export default class ProjectAccount {
    uuid: string;
    employeeId?: string;
    employeeIds?: string[];
    jiraAccountId: string;
    accountCode?: string;
    accountTitle?: string;
    accountName: string;
    price: number;
    budget: number | null;
    poNumber?: string;
    sesNumber?: string;
    contractAgreementNumber?: string;
    freeText?: string;
    includeProjectManagement?: boolean;
    effectiveFrom: string | null;
    effectiveTo: string | null;
    hasContract: boolean;
    contractFileName: string | null;
    contractUrl: string | null;
    yearlyActualCost?: number;
    yearlyBillableSeconds?: number;
    worklogFrom?: string;
    worklogTo?: string;

    constructor(init?: Partial<ProjectAccount>) {
        Object.assign(this, init);
    }
}
